import { render, staticRenderFns } from "./ScenicAreaDynamic.vue?vue&type=template&id=2cb1e8e6&scoped=true"
import script from "./ScenicAreaDynamic.vue?vue&type=script&lang=js"
export * from "./ScenicAreaDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb1e8e6",
  null
  
)

export default component.exports